import React, { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import { toInterfaceDayFormat, toInterfaceHour } from 'utils/date';

import OrderHelp from 'components/OrderHelp';

import {
  Container,
  Tabs,
  Tab,
  Card,
  WarnCard,
  WarnText,
  Row,
  Avatar,
  Text,
  LocationText,
  TextGrey,
  OrderIcon,
  CalendarIcon,
  PhoneIcon,
  LocationIcon,
  IconUser,
  WrapperIcon,
  DeliveryIcon,
} from './styles';
import { Props } from './types';

const ExtraInfo: FC<Props> = ({ order }) => {
  return (
    <Container>
      <Tabs>
        <Tab label="Order" exact to={`/history/${order.id}`} />
        <Tab label="Customer" to={`/history/${order.id}/customer`} />
        <Tab label="Courier" to={`/history/${order.id}/courier`} />
      </Tabs>
      <Switch>
        <Route path={`/history/${order.id}/customer`}>
          <Card>
            <Row>
              <WrapperIcon>
                <IconUser />
              </WrapperIcon>

              <Text>{order.customer.name.displayName}</Text>
            </Row>
            <Row>
              <WrapperIcon>
                <PhoneIcon />
              </WrapperIcon>

              <Text>{order.customer.phone}</Text>
            </Row>
            <Row>
              <WrapperIcon>
                <LocationIcon />
              </WrapperIcon>

              <LocationText>
                {order.customer.address.addressLine1} <br />
                {order.customer.address.addressLine2} <br />
                {order.customer.address.city}, {order.customer.address.state}{' '}
                {order.customer.address.zipCode}
              </LocationText>
            </Row>
          </Card>
        </Route>
        <Route path={`/history/${order.id}/courier`}>
          <Card>
            <Row>
              <WrapperIcon>
                <IconUser />
              </WrapperIcon>
              <Text>{order.courier.name.displayName}</Text>
            </Row>
            {order.courier.phone && (
              <Row>
                <WrapperIcon>
                  <PhoneIcon />
                </WrapperIcon>

                <Text>{order.courier.phone}</Text>
              </Row>
            )}
          </Card>
        </Route>
        <Route path={`/history/${order.id}`}>
          <Card>
            <Row>
              <WrapperIcon>
                <IconUser />
              </WrapperIcon>
              <Text>{order.customer.name.displayName}</Text>
            </Row>
            <Row>
              <Avatar
                src={order.integration.logo}
                alt={order.integration.name}
              />
              <Text>{order.integration.name}</Text>
              <TextGrey>· {order.integration.orderId}</TextGrey>
            </Row>
            <Row>
              <Avatar src={order.brand.logo} alt={order.brand.name} />
              <Text>{order.brand.name}</Text>
            </Row>
            <Row>
              <WrapperIcon>
                <OrderIcon />
              </WrapperIcon>

              <Text>{order.itemCount} items</Text>
            </Row>
            <Row>
              <WrapperIcon>
                <CalendarIcon />
              </WrapperIcon>
              <Text>{toInterfaceDayFormat(order.createdAt)} </Text>{' '}
              <TextGrey>· {toInterfaceHour(order.createdAt)}</TextGrey>
            </Row>
            <Row>
              <WrapperIcon>
                <DeliveryIcon />
              </WrapperIcon>

              <Text>{order.type.caption}</Text>
            </Row>
          </Card>
        </Route>
      </Switch>
      <WarnCard>
        <WarnText>
          <OrderHelp integrationName={order.integration.name} />
        </WarnText>
      </WarnCard>
    </Container>
  );
};

export default ExtraInfo;
